import script from "./DevicesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DevicesTable.vue?vue&type=script&setup=true&lang=js"

import "./DevicesTable.vue?vue&type=style&index=0&id=1c8d2c48&lang=css"

const __exports__ = script;

export default __exports__